{
	"imprintTitle": "Imprint",
	"termsAndConditionsTitle": "Terms and Conditions",
	"privacyPolicyTitle": "Privacy Policy",
	"openSourceAttributionTitle": "Open Source Attribution"
}
